import { gql } from '@apollo/client';
import { LOCATION_FIELDS_WITH_POINTS_AND_TASK_INFO } from './fragments/location';
import { BASIC_TASK_TYPE_FIELDS_FRAGMENT } from './fragments/task';

export const ADD_RESOURCE_TO_TASK = gql`
    mutation addResourceToTask($MachineId: Int!, $TaskIds: [Int!], $ProjectId: Int!) {
        addResourceToTask(
            data: { MachineId: $MachineId, TaskIds: $TaskIds, ProjectId: $ProjectId }
        ) {
            Task {
                TaskId
            }
        }
    }
`;

export const REMOVE_RESOURCE_FROM_TASK = gql`
    mutation removeResourceFromTask($TaskIds: [Int!]!, $ProjectId: Int!, $MachineId: Int!) {
        removeResourceFromTask(
            data: { TaskIds: $TaskIds, ProjectId: $ProjectId, MachineId: $MachineId }
        )
    }
`;

export const CREATE_TASK_TO_LOCATION = gql`
    mutation createTaskToLocation(
        $TaskTypeIds: [Int!]
        $LocationId: Int!
        $ProjectId: Int
        $WorkPackageId: Int
    ) {
        createTasks(
            data: {
                TaskTypeIds: $TaskTypeIds
                LocationId: $LocationId
                ProjectId: $ProjectId
                WorkPackageId: $WorkPackageId
            }
        ) {
            ...LocationFieldsWithPointsAndTaskInfo
        }
    }
    ${LOCATION_FIELDS_WITH_POINTS_AND_TASK_INFO}
`;

export const CREATE_TAS_AND_LOCATION = gql`
    mutation createTaskAndLocation(
        $TaskTypeIds: [Int!]
        $WorkPackageId: Int
        $ProjectId: Int
        $LocationName: String!
        $Points: [CreatePointInputType!]!
    ) {
        createLocation(
            data: {
                TaskTypeIds: $TaskTypeIds
                ProjectId: $ProjectId
                WorkPackageId: $WorkPackageId
                LocationName: $LocationName
                Points: $Points
            }
        ) {
            ...LocationFieldsWithPointsAndTaskInfo
        }
    }
    ${LOCATION_FIELDS_WITH_POINTS_AND_TASK_INFO}
`;

export const UPDATE_TASK_STATUS = gql`
    mutation setTaskStatus($TaskId: Int!, $TaskStatus: TaskStatusEnum!) {
        setTaskStatus(data: { TaskId: $TaskId, TaskStatus: $TaskStatus }) {
            ...LocationFieldsWithPointsAndTaskInfo
        }
    }
    ${LOCATION_FIELDS_WITH_POINTS_AND_TASK_INFO}
`;

export const UPDATE_TASK = gql`
    mutation updateTask(
        $TaskId: Int!
        $TaskTypeId: Int!
        $LocationId: Int!
        $LocationName: String!
        $Points: [UpsertPointInputType!]
        $TaskPriority: TaskPriorityEnum
    ) {
        updateTask(
            data: {
                TaskId: $TaskId
                TaskTypeId: $TaskTypeId
                Location: { LocationId: $LocationId, Name: $LocationName }
                Points: $Points
                TaskPriority: $TaskPriority
            }
        ) {
            ...LocationFieldsWithPointsAndTaskInfo
        }
    }
    ${LOCATION_FIELDS_WITH_POINTS_AND_TASK_INFO}
`;

export const DELETE_TASK = gql`
    mutation deleteTask($TaskId: Int!) {
        deleteTask(data: { TaskId: $TaskId })
    }
`;
export const GET_TASKTYPES = gql`
    query tasktypes {
        tasktypes {
            ...BasicTaskTypeFields
        }
    }
    ${BASIC_TASK_TYPE_FIELDS_FRAGMENT}
`;

export const UPDATE_TASK_DATES = gql`
    mutation setTaskPlannedDates($TaskId: Int!, $PlannedStartDate: Date, $PlannedEndDate: Date) {
        setTaskPlannedDates(
            data: {
                TaskId: $TaskId
                PlannedStartDate: $PlannedStartDate
                PlannedEndDate: $PlannedEndDate
            }
        ) {
            ...LocationFieldsWithPointsAndTaskInfo
        }
    }
    ${LOCATION_FIELDS_WITH_POINTS_AND_TASK_INFO}
`;
